import React from 'react';
import { Skeleton } from './skeleton';
import { MediaIcon } from './styled';

export const SkeletonMedia: React.FC<SkeletonProps> = props => {
  return (
    <Skeleton
      circle={props.circle}
      height={props.height}
      width={props.width}
      flex
    >
      <MediaIcon />
    </Skeleton>
  );
};

interface SkeletonProps {
  circle?: boolean;
  height?: string | number;
  width?: string | number;
}
